import { COLORS } from "@app/constants";
import React, { useEffect } from 'react';
import { useTranslation } from "react-i18next";
import useTradeStore from "../../../../hooks/trade/tradeStore";
import { OrderBookHeaderSection, Price, Total } from "./styles";

const OrderBookHeader = () => {
  const { t } = useTranslation();

  const { data: store } = useTradeStore();

  const orderType = store?.main_sub;
  const current = store?.pairs?.split("/");

  const color = COLORS.lightGray;


  return (
    <OrderBookHeaderSection>
      <Price style={{ color, fontSize: "1.1rem" }}>
        {t("price")} ({current?.[1]})
      </Price>
      <Price style={{ color, marginLeft: 10, fontSize: "1.1rem" }}>
        {t("amount")} ({orderType === 'M' ? current?.[0] : current?.[1]})
      </Price>
      <Total style={{ color, fontSize: "1.1rem" }}>
        {t("total")} ({orderType === 'M' ? current?.[0] : current?.[1]})
      </Total>
    </OrderBookHeaderSection>
  );
};

export default OrderBookHeader;
